export default "__VITE_ASSET__CofXhavR__"